"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const chain_1 = require("../chain");
const resident_1 = require("../resident");
const shared_1 = require("../shared");
// number, "=", ">", "<", "<=", ">=", "!="
// boolean "="
// text "=", "endWith", "beginWith", "include"
// array same as text
// date as number
// values 
var ERuleFieldType;
(function (ERuleFieldType) {
    ERuleFieldType["TEXT"] = "text";
    ERuleFieldType["NUMBER"] = "number";
    ERuleFieldType["BOOLEAN"] = "boolean";
    ERuleFieldType["DATE"] = "date";
    ERuleFieldType["VALUES"] = "values";
    ERuleFieldType["RELATION"] = "relation";
})(ERuleFieldType = exports.ERuleFieldType || (exports.ERuleFieldType = {}));
var ERuleRelationType;
(function (ERuleRelationType) {
    ERuleRelationType["INTERNAL"] = "internal";
    ERuleRelationType["EXTERNAL"] = "external";
})(ERuleRelationType = exports.ERuleRelationType || (exports.ERuleRelationType = {}));
var ERuleOperators;
(function (ERuleOperators) {
    ERuleOperators["EQUAL"] = "=";
    ERuleOperators["MORE_THAN"] = ">";
    ERuleOperators["MORE_THAN_EQUAL"] = ">=";
    ERuleOperators["LESS_THAN"] = "<";
    ERuleOperators["LESS_THAN_EQUAL"] = "<=";
    ERuleOperators["START_WITH"] = "startWith";
    ERuleOperators["END_WITH"] = "endWith";
    ERuleOperators["INCLUDES"] = "includes";
})(ERuleOperators = exports.ERuleOperators || (exports.ERuleOperators = {}));
var ERuleTrigger;
(function (ERuleTrigger) {
    ERuleTrigger["DAILY"] = "DAILY";
    ERuleTrigger["ON_PAYMENT_UPDATE"] = "ON_PAYMENT_UPDATE";
    ERuleTrigger["ON_PAYMENT_CREATE"] = "ON_PAYMENT_CREATE";
    ERuleTrigger["ON_TED_UPDATE"] = "ON_TED_UPDATE";
    ERuleTrigger["ON_TED_CREATE"] = "ON_TED_CREATE";
    ERuleTrigger["ON_MAILING_BATCH_UPDATE"] = "ON_MAILING_BATCH_UPDATE";
    ERuleTrigger["ON_MAILING_BATCH_CREATE"] = "ON_MAILING_BATCH_CREATE";
    ERuleTrigger["ON_DEPOSIT_UPDATE"] = "ON_DEPOSIT_UPDATE";
    ERuleTrigger["ON_DEPOSIT_CREATE"] = "ON_DEPOSIT_CREATE";
    ERuleTrigger["ON_STATEMENT_UPDATE"] = "ON_STATEMENT_UPDATE";
    ERuleTrigger["ON_STATEMENT_CREATE"] = "ON_STATEMENT_CREATE";
    ERuleTrigger["ON_USER_UPDATE"] = "ON_USER_UPDATE";
    ERuleTrigger["ON_USER_CREATE"] = "ON_USER_CREATE";
    ERuleTrigger["ON_FACILITY_SETTINGS_UPDATE"] = "ON_FACILITY_SETTINGS_UPDATE";
    ERuleTrigger["ON_FACILITY_SETTINGS_CREATE"] = "ON_FACILITY_SETTINGS_CREATE";
    ERuleTrigger["ON_PAYMENT_SETTINGS_UPDATE"] = "ON_PAYMENT_SETTINGS_UPDATE";
    ERuleTrigger["ON_PAYMENT_SETTINGS_CREATE"] = "ON_PAYMENT_SETTINGS_CREATE";
    ERuleTrigger["ON_BATCH_SETTINGS_UPDATE"] = "ON_BATCH_SETTINGS_UPDATE";
    ERuleTrigger["ON_BATCH_SETTINGS_CREATE"] = "ON_BATCH_SETTINGS_CREATE";
})(ERuleTrigger = exports.ERuleTrigger || (exports.ERuleTrigger = {}));
var ERuleAction;
(function (ERuleAction) {
    ERuleAction["CREATE_TASK"] = "CREATE_TASK";
})(ERuleAction = exports.ERuleAction || (exports.ERuleAction = {}));
exports.RULES = [
    {
        label: 'Resident',
        table: 'resident',
        property: 'resident',
        fields: [
            {
                label: 'ID',
                name: 'id',
                type: ERuleFieldType.NUMBER
            },
            {
                label: 'Origin',
                name: 'origin',
                type: ERuleFieldType.VALUES,
                values: [
                    shared_1.EOrigin.MANUAL,
                    shared_1.EOrigin.PCC,
                    shared_1.EOrigin.NCS
                ]
            },
            {
                label: 'Status',
                name: 'status',
                type: ERuleFieldType.VALUES,
                values: [
                    resident_1.EResidentStatus.ACTIVE,
                    resident_1.EResidentStatus.INACTIVE,
                    resident_1.EResidentStatus.WAITING
                ]
            },
            {
                label: 'First Name',
                name: 'fisrtName',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'Facility',
                name: 'facility',
                type: ERuleFieldType.RELATION
            },
            {
                label: 'Last Name',
                name: 'lastName',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'Origin ID',
                name: 'originid',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'Stop Sending Statements',
                name: 'stopSendingStatements',
                type: ERuleFieldType.BOOLEAN
            },
            {
                label: 'Escalate From Collections',
                name: 'escalateFromCollections',
                type: ERuleFieldType.BOOLEAN
            },
            {
                label: 'Exclude From Collections',
                name: 'excludeFromCollections',
                type: ERuleFieldType.BOOLEAN
            },
            {
                label: 'Paperless Statement',
                name: 'paperlessStatement',
                type: ERuleFieldType.BOOLEAN
            },
            {
                label: 'Paperless Statement',
                name: 'paperlessStatement',
                type: ERuleFieldType.BOOLEAN
            },
            {
                label: 'Indigent',
                name: 'indigent',
                type: ERuleFieldType.BOOLEAN
            },
            {
                label: 'Hic Number',
                name: 'hicNumber',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'Medicaid Number',
                name: 'medicaidNumber',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'MBI Number',
                name: 'mbiNumber',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'In Collections',
                name: 'inCollections',
                type: ERuleFieldType.BOOLEAN
            },
            {
                label: 'Escalation Paused Until',
                name: 'escalationPausedUntil',
                type: ERuleFieldType.DATE
            },
            {
                label: 'Is Escalated',
                name: 'isEscalated',
                type: ERuleFieldType.BOOLEAN
            },
            {
                label: 'Exclude From Escalation',
                name: 'excludeFromEscalation',
                type: ERuleFieldType.BOOLEAN
            },
            {
                label: 'CC Customer Account Number',
                name: 'ccCustomerAccountNumber',
                type: ERuleFieldType.NUMBER
            },
            {
                label: 'CC Customer eCheck Number',
                name: 'ccCustomerEcheckNumber',
                type: ERuleFieldType.NUMBER
            },
            {
                label: 'Deliver To Room',
                name: 'deliverToRoom',
                type: ERuleFieldType.BOOLEAN
            },
            {
                label: 'Balance',
                name: 'balance',
                type: ERuleFieldType.NUMBER
            },
            {
                label: 'NCS Resident Id',
                name: 'ncsResidentId',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'In NCS Collections',
                name: 'inNCSCollections',
                type: ERuleFieldType.BOOLEAN
            },
            {
                label: 'Memo',
                name: 'memo',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'Created At',
                name: 'createdAt',
                type: ERuleFieldType.DATE
            },
            {
                label: 'Updated At',
                name: 'updatedAt',
                type: ERuleFieldType.DATE
            }
        ],
        relations: [
            {
                label: 'Facility',
                name: 'facility',
                type: ERuleRelationType.INTERNAL,
                property: 'facility'
            }
        ]
    },
    {
        label: 'Facility',
        table: 'facility',
        property: 'facility',
        fields: [
            {
                label: 'ID',
                name: 'id',
                type: ERuleFieldType.NUMBER
            },
            {
                label: 'Name',
                name: 'name',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'Origin',
                name: 'origin',
                type: ERuleFieldType.VALUES,
                values: [
                    shared_1.EOrigin.MANUAL,
                    shared_1.EOrigin.NCS,
                    shared_1.EOrigin.PCC
                ]
            },
            {
                label: 'Username',
                name: 'username',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'Password',
                name: 'password',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'Origin ID',
                name: 'originid',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'Deleted',
                name: 'deleted',
                type: ERuleFieldType.BOOLEAN
            },
            {
                label: 'Date Pulled',
                name: 'datePulled',
                type: ERuleFieldType.DATE
            },
            {
                label: 'Contact Person',
                name: 'contactPerson',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'Statement Message',
                name: 'statementMessage',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'Email',
                name: 'email',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'Phone',
                name: 'phone',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'Website',
                name: 'website',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'State',
                name: 'state',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'Logo',
                name: 'logo',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'Billing Day',
                name: 'billingDay',
                type: ERuleFieldType.NUMBER
            },
            {
                label: 'Street',
                name: 'street',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'City',
                name: 'city',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'Zip',
                name: 'zip',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'Resident Mail Contacts',
                name: 'residentMailContacts',
                type: ERuleFieldType.TEXT
                // is ARRAY
            },
            {
                label: 'Statement Number Start',
                name: 'statementNumberStart',
                type: ERuleFieldType.NUMBER
            },
            {
                label: 'Residents Count',
                name: 'residentsCount',
                type: ERuleFieldType.NUMBER
            },
            {
                label: 'Users Count',
                name: 'usersCount',
                type: ERuleFieldType.NUMBER
            },
            {
                label: 'Chain',
                name: 'chain',
                type: ERuleFieldType.RELATION
            }
        ],
        relations: [
            {
                label: 'Chain',
                name: 'chain',
                type: ERuleRelationType.INTERNAL,
                property: 'chain'
            },
            {
                label: 'Resident',
                name: 'resident',
                type: ERuleRelationType.EXTERNAL,
                property: 'resident'
            }
        ]
    },
    {
        label: 'Chain',
        table: 'chain',
        property: 'chain',
        fields: [
            {
                label: 'ID',
                name: 'id',
                type: ERuleFieldType.NUMBER
            },
            {
                label: 'Name',
                name: 'name',
                type: ERuleFieldType.TEXT
            },
            {
                label: 'Facilities Count',
                name: 'facilitiesCount',
                type: ERuleFieldType.NUMBER
            },
            {
                label: 'Status',
                name: 'status',
                type: ERuleFieldType.VALUES,
                values: [
                    chain_1.EChainStatus.ACTIVE,
                    chain_1.EChainStatus.NOT_ACTIVE
                ]
            },
            {
                label: 'Created At',
                name: 'createdAt',
                type: ERuleFieldType.DATE
            },
            {
                label: 'Updated At',
                name: 'updatedAt',
                type: ERuleFieldType.DATE
            },
            {
                label: 'Is FCC',
                name: 'isFCC',
                type: ERuleFieldType.BOOLEAN
            }
        ],
        relations: [
            {
                label: 'Facility',
                name: 'facility',
                type: ERuleRelationType.EXTERNAL,
                property: 'facility'
            },
            {
                label: 'Resident',
                name: 'resident',
                type: ERuleRelationType.EXTERNAL,
                property: 'resident'
            }
        ]
    }
];
